module.exports = __webpack_public_path__ + "img/Standard_Chartered.b79c3f74.svg";